const ROLE_ALIASES: Record<string, string> = {
  'dispozisyon uzmani': 'dispatcher',
  'dispozisyon uzmanı': 'dispatcher',
  'dispozisyon sorumlusu': 'dispatcher',
  dispatcher: 'dispatcher',
  'operasyon planlayici': 'planner',
  'operasyon planlayıcı': 'planner',
  planner: 'planner',
};

export const normalizeRoleId = (value: any): string => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const lowered = raw.toLocaleLowerCase('tr-TR');
  return ROLE_ALIASES[lowered] || raw;
};

export const getUserRoles = (user: any): string[] => Array.from(new Set([
  normalizeRoleId(user?.role),
  ...(Array.isArray(user?.roles) ? user.roles.map(normalizeRoleId) : []),
  ...(Array.isArray(user?.roleIds) ? user.roleIds.map(normalizeRoleId) : []),
  ...(Array.isArray(user?.role_ids) ? user.role_ids.map(normalizeRoleId) : []),
].filter(Boolean)));

export const hasUserRole = (user: any, ...roles: string[]) => getUserRoles(user).some((role) => roles.includes(role));
export const isCorporateExternalTransportUser = (user: any) => hasUserRole(user, 'corporate-external-transport', 'corporate-external-transport-user');
export const isInternalDriverUser = (user: any) => hasUserRole(user, 'internal-driver') || user?.driverType === 'internal';
export const isExternalDriverUser = (user: any) => hasUserRole(user, 'external-driver', 'corporate-external-transport-driver', 'corporate-external-transport-user') || user?.driverType === 'external';
export const isCorporateExternalTransportSubUser = (user: any) => hasUserRole(user, 'corporate-external-transport-user');
export const isCorporateManagedExternalDriverUser = (user: any) => isExternalDriverUser(user) && Boolean(user?.externalTransportAccountUserId || user?.external_transport_account_user_id);
export const isAnyDriverUser = (user: any) => isInternalDriverUser(user) || isExternalDriverUser(user);
